import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux'
import { signOut } from '../../store/actions/authActions'
import M from 'materialize-css';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

M.AutoInit();

const SignedInLinks = (props) => {
  return (
    <ul className="right">
      <li><NavLink className="white-text lighten-1 hide-on-med-and-down" to='/hastemplate'>New NDA</NavLink></li>
      <li><a className="white-text lighten-1 hide-on-med-and-down" onClick={props.signOut} href="signout">Log out</a></li>
      <li><NavLink className="white-text lighten-1" to='/signin'>
        <a className='dropdown-trigger btn-floating btn-large white teal-text' href="dropdown1" data-target='dropdown1'>{props.profile.initials}</a>

        <ul id='dropdown1' className='dropdown-content'>
          <li><NavLink className="lighten-1" to='/'>Home</NavLink></li>
          <li><NavLink className="lighten-1" to='/dashboard'>View</NavLink></li>
          <li><NavLink className="lighten-1" to='/hastemplate'>New</NavLink></li>
          <li><NavLink className="lighten-1" to='/profile'>Profile</NavLink></li>
          <li><NavLink className="lighten-1" to='/mysign'>E-sign</NavLink></li>
          <li className="divider" tabIndex="-1"></li>
          <li><a className="teal-text lighten-1" onClick={props.signOut} href="signout">Logout</a></li>
        </ul>

      </NavLink>
      </li>

    </ul >
  )
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(signOut())
  }
}

export default connect(null, mapDispatchToProps)(SignedInLinks);